import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import theme from "../shared/styles/muiTheme.js";
import { createBrowserHistory } from "history";
import React from "react";
import ReactDOM from "react-dom";
import { Route, Router, Switch } from "react-router-dom";

import {
  builderIOInit,
  identifyUser,
  posthogInit,
  posthogStartSessionRecording,
} from "../shared/utils/analytics";

import { ApolloClient, ApolloProvider, createHttpLink } from "@apollo/client";
import { InMemoryCache } from "@apollo/client/cache";
import { setContext } from "@apollo/client/link/context";

const httpLink = createHttpLink({
  uri: "/me/gql/graphql",
  credentials: "same-origin", // send up cookies for authentication
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

import "./styles/material-overrides.css";

import indexRoutes from "./routes/index.js";


builderIOInit();

posthogInit();
identifyUser();
posthogStartSessionRecording();

const hist = createBrowserHistory();

// Track protected page loads with Converge
const trackProtectedPageLoad = (location) => {
  let pathname = location.pathname || window.location.pathname;

  // List of paths to track as protected page loads
  const protectedPaths = [
    "/me",
    "/me/portal",
    "/me/refills",
    "/me/login",
    "/me/password-reset",
    "/me/messages/care",
    "/me/payment-portal",
  ];

  // Normalize pathname: remove trailing slash and query string
  pathname = pathname.replace(/\/$/, "").split("?")[0];

  // Check if current path matches any protected paths (exact match)
  const isProtectedPath = protectedPaths.includes(pathname);

  if (isProtectedPath && window.ConvergeTracking) {
    console.log("[Converge] Tracking $protected_page_load for:", pathname);
    window.ConvergeTracking.track("$protected_page_load");
  }
};

// Track initial page load
trackProtectedPageLoad(hist.location);

// Listen for route changes
hist.listen((location) => {
  trackProtectedPageLoad(location);
});

ReactDOM.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <ApolloProvider client={client}>
        <Router history={hist}>
          <Switch>
            {indexRoutes.map((prop, key) => {
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
        </Router>
      </ApolloProvider>
    </ThemeProvider>
  </StyledEngineProvider>,
  document.getElementById("portal_container"),
);
